import React from 'react';
import styled from '@emotion/styled';
import { fieldTextFontSize } from '../../styled';
export var TEXT_TYPE_TEST_ID = 'link-datasource-render-type--text';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var TextWrapper = styled.span({
  fontSize: fieldTextFontSize
});
var TextRenderType = function TextRenderType(_ref) {
  var text = _ref.text,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEXT_TYPE_TEST_ID : _ref$testId;
  if (!(text && typeof text === 'string')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextWrapper, {
    "data-testid": testId
  }, text), /*#__PURE__*/React.createElement("br", null));
};
export default TextRenderType;